import { config } from './../../../config';
import { environment } from 'environments/environment';
import { Injectable } from "@angular/core";


@Injectable()
export class ApiGatewayHelperService {

    spaceId;

    getApiGatewayPrefixUrl(appendSpaceId = false) {
        let apiGatewayUrl = config.apiGatewayUrl;
        const spaceId = this.getSpaceId();

        if (spaceId && appendSpaceId) {
            apiGatewayUrl += spaceId + '/';
        }
        return apiGatewayUrl;
    }

    setSpaceId(spaceId): void {
        this.spaceId = spaceId;
    }

    getSpaceId(): string {
        return this.spaceId;
    }
    
    getAPIAuthToken() {
        if (environment.isDesktopApp) {
            return DLS_IPCCallers.GEN_API_AUTH_TOKEN();
        } else {
            return Promise.resolve({});
        }
    }

    /**
     * method to return cookie value by cookie name
     * @param name : cookie name
     * @returns : cookie value
     */
    getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }
    
}
